import React from 'react';
import "../PC.css";

const Services = () => {
  return (
    <div className="ABOUTmainContainer">
    <div className="allRightContent">
      <div className="allRightContentHeading" >Placement Cell Services</div>

      <div className="allRightContentProfile">
        {/* Profile information */}
        <center></center>
        <br />
        {/* Profile description */}
       <p>❖ Student registration, result update, and profile update.</p>
       <p>❖ Communicate with industries to collect vacancies.</p>
       <p>❖ Spot registration of students and industries.</p>
       <p>❖ Arrange institute-level walk-in interviews.</p>
       <p>❖ Coordinate the activities during placement camps.</p>
      </div>
    </div>
  </div>
  );
};

export default Services;
